// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu-label > div[data-v-2596e7db]:hover {\n  font-weight: bold;\n}", ""]);
// Exports
module.exports = exports;
